import { Component, Input, OnChanges, OnInit } from "@angular/core"
import { ImageMedia } from "../../models/resource/media"
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser"
import { Observable, Subject } from "rxjs"
import { takeUntil, tap } from "rxjs/operators"
import { CautionFlagsService } from "../../services/caution-flags.service"

@Component({
    selector: "app-image-preview",
    templateUrl: "./image-preview.component.html",
    styleUrls: ["./image-preview.component.scss"],
    standalone: false,
})
export class ImagePreviewComponent implements OnInit, OnChanges {
    @Input() public imageMedia: ImageMedia
    public srcSet: SafeResourceUrl
    isCautionFlagContainerDisplayed: boolean = false
    cautionFlagButtonName: string = "View Image"

    private destroyed$: Subject<void> = new Subject<void>()

    cautionFlagDisplayObservable: Observable<boolean> =
        this.cautionFlagsService.cautionFlagDisplayObservable.pipe(
            takeUntil(this.destroyed$),
            tap((nextState: boolean) => (this.isCautionFlagContainerDisplayed = nextState))
        )

    constructor(
        public sanitizer: DomSanitizer,
        private cautionFlagsService: CautionFlagsService
    ) {}

    ngOnInit() {
        this.cautionFlagDisplayObservable.subscribe()
    }

    public ngOnChanges(): void {
        const rawSrcSet = this.imageMedia.posterImage.getSrcSetFormat([375, 785, 800])
        this.srcSet = this.sanitizer.bypassSecurityTrustResourceUrl(rawSrcSet)
    }

    public expand(event): void {
        event.preventDefault()
        window.open(
            this.imageMedia.canonicalUrl,
            "_blank",
            "height=480,width=640,scrollbars=yes,resizable=yes"
        )
    }
}
